import angular from 'angular';
import angularResource from 'angular-resource';
import config from '../ConfigModule/ConfigModule';

export default angular.module('cms.log.resource', [angularResource, config])
    .factory('LogResource', function ($resource, CONFIG) {
        /** @ngInject */

        return $resource(CONFIG.API_URL + '/logs', {}, {
                'get': {cancellable: true, method: 'GET'},
                'save': {method: 'POST'},
                'remove': {method: 'DELETE', url: CONFIG.API_URL + '/logs/:id'},
                'delete': {method: 'DELETE', url: CONFIG.API_URL + '/logs/:id'},
                'deleteOld': {method: 'DELETE', url: CONFIG.API_URL + '/logs'}
            },
            {
                stripTrailingSlashes: true
            })

    })
    .name;



// WEBPACK FOOTER //
// ./src/cmsCore/LogsModules/LogResource.js